import React from 'react';
import { motion } from 'motion/react';

export const AnimateIn = (props: { className?: string; children: React.ReactNode }) => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: 30 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      viewport={{ once: true }}
      className={props.className}
    >
      {props.children}
    </motion.div>
  );
};
